import { autoMount } from '../../../utils/autoMount';
import { CompanyRegisterForm } from '../../../components/pages/companyRegisterForm';

autoMount({ CompanyRegisterForm });
